import { Injectable, WritableSignal, signal } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class AppService {
    appInitStatus: WritableSignal<'COMPLETE' | 'ERROR' | 'LOADING'> = signal('LOADING');

}
